import axios from '../../config/axiosConfig';

export default {
  get: () => axios.get('/payment/get'),
  add: (data) => axios.post('/payment/add', data),
  update: (data) => axios.post('/payment/update', data),
};
